import { forwardRef } from 'react';

export type HeaderTitleSize = 'sm' | 'md' | 'lg';
export type HeaderTitleVariant = 'primary' | 'secondary';

export interface HeaderTitleProps extends React.HTMLAttributes<HTMLHeadingElement> {
  size?: HeaderTitleSize;
  variant?: HeaderTitleVariant;
  children: React.ReactNode;
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
}

const HeaderTitle = forwardRef<HTMLHeadingElement, HeaderTitleProps>(({
  size = 'md',
  variant = 'primary',
  children,
  as: Component = 'h1',
  className = '',
  ...props
}, ref) => {
  const getTitleClasses = () => {
    const baseClasses = ['font-semibold', 'truncate'];

    // Size classes
    const sizeClasses = {
      sm: ['text-lg'],
      md: ['text-xl'],
      lg: ['text-2xl']
    };

    // Variant classes
    const variantClasses = {
      primary: ['text-text-primary'],
      secondary: ['text-text-secondary']
    };

    return [
      ...baseClasses,
      ...sizeClasses[size],
      ...variantClasses[variant],
      className
    ].filter(Boolean).join(' ');
  };

  return (
    <Component
      ref={ref}
      className={getTitleClasses()}
      {...props}
    >
      {children}
    </Component>
  );
});

HeaderTitle.displayName = 'HeaderTitle';

export default HeaderTitle;